module.exports = __webpack_public_path__ + "img/ic_wait.6340fe7d.svg";